export const ORIENTATIONS = ["Compass.WEST", "Compass.EAST", "Compass.NORTH", "Compass.SOUTH"];

export type PortComboSortKey =
  | "name"
  | "index"
  | "inputs"
  | "outputs"
  | "pads"
  | "settings"
  | "alignAtPeak"
  | "alignPwrRng"
  | "measurePwrRng"
  | "zMargin"
  | "probeCheck"
  | "blindStep"
  | "dynamicAlignment";

export type OpticalPortSortKey = "name" | "orientation" | "cellPort" | "tag" | "x" | "y";
export type ProbePadSortKey = "name" | "orientation" | "x" | "y";
